export default "__VITE_PUBLIC_ASSET__1833815b__"